import { TextField, Typography } from '@mui/material';
import React from 'react';

interface VemigoTextFeildProps {
  style?: React.CSSProperties;
  autoFocus?: boolean;
  multiline?: boolean;
  rows?: number;
  id?: string;
  type?: string;
  fullWidth?: boolean;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  maxChars?: number;
  useFor?: string;
  counter?: boolean;
  disable?: boolean;
  readonly?: boolean;
}

const VemigoTextFeild: React.FC<VemigoTextFeildProps> = ({
  style,
  autoFocus,
  multiline,
  rows,
  id,
  type,
  fullWidth,
  value,
  onChange,
  maxChars,
  useFor,
  disable,
  counter = true,
  readonly = false
}) => {
  const handleChange = (e) => {
    if (!onChange) return;

    let inputValue = e.target.value;

    // Handle phone number with country code case
    if (useFor && useFor[0] === '+') {
      // Remove all non-digit characters except '+' and '-'
      inputValue = inputValue.replace(/[^0-9+-]/g, '');
      
      // If we have the country code prefix
      if (inputValue.startsWith(useFor)) {
        // Ensure proper formatting with hyphen
        if (!inputValue.includes('-') && inputValue.length > useFor.length) {
          inputValue = `${useFor}-${inputValue.slice(useFor.length)}`;
        }
        
        // Enforce max length (country code + hyphen + digits)
        const maxDigits = maxChars - useFor.length - 1; // -1 for the hyphen
        const digits = inputValue.slice(useFor.length + 1);
        if (digits.length > maxDigits) {
          inputValue = `${useFor}-${digits.slice(0, maxDigits)}`;
        }
      } else if (inputValue.startsWith('+')) {
        // If it starts with a different country code, leave as is
      } else {
        // If no country code, add it with hyphen
        inputValue = `${useFor}-${inputValue.replace(/\D/g, '')}`;
      }
    } 
    // Handle regular mobile number case
    else if (type === 'mobNumber') {
      inputValue = inputValue.replace(/\D/g, '');
      if (inputValue.length > maxChars) {
        inputValue = inputValue.slice(0, maxChars);
      }
    }

    // Call the parent onChange with the processed value
    onChange({ ...e, target: { ...e.target, value: inputValue } });
  };

  // Format the displayed value
  const displayValue = (() => {
    if (!useFor || useFor[0] !== '+') return value || '';
    
    // If we have a value but no country code, add it
    if (value && !value.startsWith('+')) {
      return `${useFor}-${value}`;
    }
    return value || useFor; // Show country code when empty
  })();

  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <TextField
        style={{ ...style, background: readonly ? '#F0F0F0' : '#FFFFFF' }}
        autoFocus={autoFocus}
        multiline={multiline}
        rows={rows}
        margin="dense"
        id={id}
        type={type === 'mobNumber' ? 'tel' : type}
        fullWidth={fullWidth}
        value={displayValue}
        onChange={handleChange}
        inputProps={{ 
          maxLength: useFor ? maxChars + useFor.length + 1 : maxChars // +1 for hyphen
        }}
        InputProps={{
          readOnly: readonly
        }}
        disabled={disable}
      />
      {counter && (
        <Typography
          variant="caption"
          color="textSecondary"
          style={{ textAlign: 'left' }}
        >
          {`${(displayValue || '').length}/${useFor ? maxChars + useFor.length + 1 : maxChars}`}
        </Typography>
      )}
    </div>
  );
};

export default VemigoTextFeild;
